import React from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  // Generate page numbers to display
  const generatePageNumbers = () => {
    // If total pages is 7 or less, show all pages
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    // Complex logic for showing pages around current page
    const pages = [];

    // Always show first and last page
    if (currentPage <= 4) {
      // Show first 5 pages, ellipsis, and last page
      pages.push(...[1, 2, 3, 4, 5, 0, totalPages]);
    } else if (currentPage >= totalPages - 3) {
      // Show first page, ellipsis, last 5 pages
      pages.push(
        1,
        0,
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages
      );
    } else {
      // Show first page, ellipsis, current page surroundings, ellipsis, last page
      pages.push(
        1,
        0,
        currentPage - 2,
        currentPage - 1,
        currentPage,
        currentPage + 1,
        currentPage + 2,
        0,
        totalPages
      );
    }

    // Remove duplicates and sort
    return [...new Set(pages)].filter((p) => p > 0).sort((a, b) => a - b);
  };

  const pageNumbers = generatePageNumbers();

  return (
    <div className="pagination__cont">
      {/* Previous Button */}
      <button
        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1}
        className="next__prev__btn"
      >
        <ArrowLeft strokeWidth={1.5} />
        <p>Previous</p>
      </button>

      {/* Page Numbers */}
      <div className="pagination__btn__cont">
        {pageNumbers.map((page, index) => {
          // Check if this is an ellipsis
          if (page === 0) {
            return (
              <span key={`ellipsis-${index}`} className="pagination__btn">
                ...
              </span>
            );
          }

          return (
            <button
              key={page}
              onClick={() => onPageChange(page)}
              className={`
                pagination__btn
                ${currentPage === page ? "pagination__btn__active" : ""}
              `}
            >
              {page}
            </button>
          );
        })}
      </div>

      {/* Next Button */}
      <button
        onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage === totalPages}
        className="next__prev__btn"
      >
        <p>Next</p>
        <ArrowRight strokeWidth={1.5} />
      </button>
    </div>
  );
};

export default Pagination;
